import PropTypes from 'prop-types';

import Table from 'components/table/table';
import {
  columnShape,
  metaShape,
  polygraphyShape,
  teleconsultationShape,
} from 'helpers/shared_types';

const MainViewWithTable = ({
  data,
  children,
  columns,
  fetchData,
  fetching,
  meta,
  onDatePick,
  onSelect,
  onTextUpdate,
  title,
  accessor,
}) => {
  const tableProps = {
    accessor,
    columns,
    data,
    fetchData,
    fetching,
    hasViewBar: true,
    meta,
    onDatePick,
    onSelect,
    onTextUpdate,
  };

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            {title}
          </h2>
          <section className="view-actions">{children}</section>
        </header>
        <section className="view-container">
          <Table {...tableProps} />
        </section>
      </section>
    </main>
  );
};

MainViewWithTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([teleconsultationShape, polygraphyShape]),
  ),
  columns: PropTypes.arrayOf(columnShape),
  fetchData: PropTypes.func,
  fetching: PropTypes.bool,
  meta: metaShape,
  onDatePick: PropTypes.func,
  onSelect: PropTypes.func,
  onTextUpdate: PropTypes.func,
  title: PropTypes.string,
  accessor: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default MainViewWithTable;
